import { Trans } from "@web-monorepo/i18n/macro";
import { DDSBodyText, DDSButton, DDSHeadlineText } from "@web-monorepo/dds";
import * as React from "react";
import ShadowCard from "./ShadowCard";
import styles from "./ShareToStory.module.css";

// TODO: these types should move into pods/webviewInit/index when that is typescript
export interface ShareToStoryAction {
  type: "webview/shareToStory";
  payload: {
    photoUrl: string;
  };
}

type GoToLaunchpadFunction = () => void;
interface ShareToStoryProps {
  goToLaunchpad: GoToLaunchpadFunction;
  imageUrl: string;
  defaultCopy: string;
}

const ShareToStory: React.FC<ShareToStoryProps> = ({ imageUrl, goToLaunchpad, defaultCopy }) => {
  const text = defaultCopy;

  return (
    <div className={styles.app}>
      <ShadowCard className={styles.card}>
        <div>
          <DDSHeadlineText as="h3" level="sm">
            <Trans>All done!</Trans>
          </DDSHeadlineText>
          <DDSBodyText as="p" variant="secondary" className={styles.description}>
            {text}
          </DDSBodyText>
          <div className={styles.imageWrapper}>
            <img src={imageUrl} className={styles.image} alt="" />
          </div>
        </div>
      </ShadowCard>
      <DDSButton
        data-name="share_to_story:modal_actions.done"
        onClick={goToLaunchpad}
        width="fill"
        className={styles.doneButton}
      >
        <Trans>Done</Trans>
      </DDSButton>
    </div>
  );
};

export default ShareToStory;
